<template>
  <div
    v-if="questionnaire.questions"
    class="grid grid-cols-[2fr_3fr] gap-2 p-3 mx-auto border rounded-md h-full">
    <div class="h-full p-2 overflow-y-auto rounded-md bg-theme-50">
      <div v-for="(group, groupId) in groupedQuestions" :key="groupId" class="">
        <div
          @click="toggleGroup(groupId)"
          class="flex items-center justify-between p-4 mb-2 bg-white rounded-md cursor-pointer text-theme-600">
          <p>{{ group.groupItemName }}</p>
          <IconChevronUpDown class="w-4 h-4" />
        </div>
        <div v-show="isGroupVisible(groupId)" class="p-1">
          <div
            v-for="(materialGroup, idx) in group.groupItems"
            :key="idx"
            class="mb-1 border-b-2 cursor-pointer border-b-white">
            <p class="p-2 text-sm text-gray-600 rounded-sm">
              {{ materialGroup }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="h-full px-2 space-y-3">
      <QuestionnairesGenericQuestionCard :questions="questionnaire.questions" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import QuestionnairesGenericQuestionCard from './QuestionnairesGenericQuestionCard.vue';
import IconChevronUpDown from '@/assets/icons/IconChevronUpDown.vue';
import type { GroupItemsWithMaterials } from '@/types/Groups';
import type { Questionnaire } from '@/types/Questionnaires';
import { getGroupItemsForQstGenericGroupsMaterials } from '@/services/api/groups';

const props = defineProps<{
  questionnaire: Questionnaire;
}>();

const groupItems = ref<GroupItemsWithMaterials[]>();
onMounted(async () => {
  if (!props.questionnaire.bindingId) return;
  const res = await getGroupItemsForQstGenericGroupsMaterials(props.questionnaire.bindingId);
  if (res) groupItems.value = res.data;
});

const groupedQuestions = computed(() => {
  if (!groupItems.value) return;
  const groups: Record<string, { groupItemName: string; groupItems: any[] }> = {};

  groupItems.value.forEach((item) => {
    const { groupItemId, groupItemName, materialName } = item;

    if (!groups[groupItemId]) {
      groups[groupItemId] = {
        groupItemName: groupItemName,
        groupItems: [],
      };
    }

    groups[groupItemId].groupItems.push(materialName);
  });
  return groups;
});

const visibleGroups = ref<Record<string, boolean>>({});

const toggleGroup = (groupId: string) => {
  visibleGroups.value[groupId] = !visibleGroups.value[groupId];
};

const isGroupVisible = (groupId: string) => {
  return !!visibleGroups.value[groupId];
};
</script>
